var WarmupQuestions = require("lib/academic/WarmupQuestions");

class FictionSettingQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionSettingQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [TIME_STAGE];
		}

		if (!answers[TIME]) {
			return [TIME_STAGE];
		}
		if (!answers[PLACE]) {
			return [PLACE_STAGE];
		}

		if (this.props.level == "1") {
			return [PLACE_STAGE, true];
		} else if (!answers[DESCRIPTOR]) {
			return [DESCRIPTOR_STAGE];
		} else {
			return [DESCRIPTOR_STAGE, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		if (this.props.level != "1") {
			var additionalTimeLabel = (
				<span>
					<br />
					{ this.props.getTextF("label2", TIME_STAGE) }
				</span>
			);
		}

		var timeDisplay = (
			<div>
				{ this.props.getTextF("label1", TIME_STAGE) }
				{ additionalTimeLabel }
				{ this.props.renderInputF(TIME) }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			var placeDisplay = (
				<div>
					{ this.props.getTextF("label1", PLACE_STAGE) }
					{ this.props.renderInputF(PLACE) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			var descriptorDisplay = (
				<div>
					{ this.props.getTextF("label1", DESCRIPTOR_STAGE) }
					{ this.props.renderMultiSelectF("choices1", DESCRIPTOR_STAGE, DESCRIPTOR, 1) }
				</div>
			);
		}

		return (
			<div>
				{ timeDisplay }
				{ placeDisplay }
				{ descriptorDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

FictionSettingQuestion.STEM = "fsetting";

// stages
var TIME_STAGE = "time";
var PLACE_STAGE = "place";
var DESCRIPTOR_STAGE = "descriptor";

var STAGES = [
	TIME_STAGE, PLACE_STAGE, DESCRIPTOR_STAGE
];

// answer keys
var TIME = "time";
var PLACE = "place";
var DESCRIPTOR = "descriptor"

FictionSettingQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderMultiSelectF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = FictionSettingQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionSettingQuestion.js